import React, { useState } from "react";
import { Tab, Tabs } from "@blueprintjs/core";
import { EnrollmentActivitySummaryTable } from "./enrollment-activity-summary-table";
import { EnrollmentActivitySummaryByDayTable } from "./enrollment-activity-summary-by-day-table";
import { TableDatePicker } from "./table-date-picker";

const TAB_IDS = {
  enrollmentActivitySummaryByDay: "enrollment-activity-summary-by-day",
  enrollmentActivitySummaryRawData: "enrollment-activity-summary-raw-data",
};

export function EnrollmentActivitySummaryTabsUnit() {
  const defaultTabId = TAB_IDS.enrollmentActivitySummaryByDay;
  const [selectedTabId, setSelectedTabId] = useState(defaultTabId);
  const handleTabChange = (newTabId, prevTabId, event) => {
    setSelectedTabId(newTabId);
  };

  const [activityByDaySelectedStartDate, setActivityByDaySelectedStartDate] =
    useState(null);
  const [activityByDaySelectedEndDate, setActivityByDaySelectedEndDate] =
    useState(null);
  const activityByDayRibbonElements = [
    <TableDatePicker
      selectedStartDate={activityByDaySelectedStartDate}
      setSelectedStartDate={setActivityByDaySelectedStartDate}
      selectedEndDate={activityByDaySelectedEndDate}
      setSelectedEndDate={setActivityByDaySelectedEndDate}
      downloadUrl="enrollment_activity_summary_by_day/download"
      key="activity-by-day-date-picker"
    />,
  ];

  const [
    activityRawDataSelectedStartDate,
    setActivityRawDataSelectedStartDate,
  ] = useState(null);
  const [activityRawDataSelectedEndDate, setActivityRawDataSelectedEndDate] =
    useState(null);
  const activityRawDataRibbonElements = [
    <TableDatePicker
      selectedStartDate={activityRawDataSelectedStartDate}
      setSelectedStartDate={setActivityRawDataSelectedStartDate}
      selectedEndDate={activityRawDataSelectedEndDate}
      setSelectedEndDate={setActivityRawDataSelectedEndDate}
      downloadUrl="enrollment_activity_summary/download"
      key="activity-raw-data-date-picker"
    />,
  ];

  return (
    <div
      css={`
        width: 100%;
        height: 100%;
      `}
    >
      <Tabs
        onChange={handleTabChange}
        selectedTabId={selectedTabId}
        large
        fill
        renderActiveTabPanelOnly={true}
        css={`
          margin-top: -15px;
        `}
      >
        <Tab
          id={TAB_IDS.enrollmentActivitySummaryByDay}
          title="Enrollment Activity by Day"
          panel={
            <EnrollmentActivitySummaryByDayTable
              customRibbonElements={activityByDayRibbonElements}
            />
          }
        />
        <Tab
          id={TAB_IDS.enrollmentActivitySummaryRawData}
          title="Enrollment Activity Raw Data"
          panel={
            <EnrollmentActivitySummaryTable
              customRibbonElements={activityRawDataRibbonElements}
            />
          }
        />
      </Tabs>
    </div>
  );
}
